import {EventBus} from '../EventBus'

interface EventHandler {
  event: string
  handler: (event: any) => void
}

interface StrategyEvents {
  'strategy:ready': void
  'strategy:data': void
  'strategy:stream:audio': {stream: MediaStream}
  'strategy:stream:video': {stream: MediaStream}
  'strategy:error': {error: any}
  'strategy:connections': void
  'strategy:screensharingStarted:viewer': {stream: MediaStream}
  'strategy:recording:started': void
  'strategy:recording:stopped': void
  'strategy:failed': void
}
export default class Strategy extends EventBus<StrategyEvents> {
  protected iceServers: RTCIceServer[] = []
  protected bufferMessages: string[] = []
  constructor() {
    super()
  }

  setIceServers(iceServers: RTCIceServer[]) {
    this.iceServers = iceServers
  }

  destroy() {}
}
